import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdContentCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';
import { AysCodeGroup } from '@bindoc-projects/code-domain-lib';

export const BD_ICD_CHAPTER_CONTENT_CONDITION_ID = 'icdChapter';
export const FilterConditionIcdCodeChapterPluginType: FilterConditionPluginSpecification<
  AysCodeGroup[],
  FilterConditionIcdCodeChapterDto,
  BdIcdChapterContentCondition
> = {
  type: 'icdChapter',
  category: 'case',
  displayName: { de: 'ICD-Kapitel' },
  sortingIndex: 8,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionIcdCodeChapterDto,
  ): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionIcdCodeChapterPlugin(
        obj.chapters.map((it) => AysCodeGroup.fromObject(it)),
      );
  },
  fromCondition(
    jsonObj: BdIcdChapterContentCondition,
  ): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionIcdCodeChapterPlugin(
        (jsonObj.includes ?? []).map((it) => AysCodeGroup.fromObject(it)),
      );
  },
  newInstance(): FilterConditionPluginImpl<AysCodeGroup[]> {
    return new FilterConditionIcdCodeChapterPlugin([]);
  },
};

export class FilterConditionIcdCodeChapterPlugin extends FilterConditionPluginImpl<
  AysCodeGroup[],
  FilterConditionIcdCodeChapterDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    AysCodeGroup[],
    FilterConditionIcdCodeChapterDto,
    BdIcdChapterContentCondition
  > = FilterConditionIcdCodeChapterPluginType;

  constructor(private chapters: AysCodeGroup[]) {
    super(FilterConditionIcdCodeChapterPluginType.type);
  }

  clone(): FilterConditionIcdCodeChapterPlugin {
    return new FilterConditionIcdCodeChapterPlugin([
      ...this.chapters.map((it) => it.clone()),
    ]);
  }

  override equals(other: FilterConditionIcdCodeChapterPlugin): boolean {
    return (
      super.equals(other) &&
      BdArrayUtil.equals(
        this.chapters,
        other.chapters,
        (a, b) => a.name === b.name && a.codingSystem === b.codingSystem,
      )
    );
  }

  override validationToText(): string {
    if (this.chapters.length === 0) {
      return 'Mindestens ein ICD-Kapitel auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdIcdChapterContentCondition(this.chapters, []);
  }

  toJSON(): FilterConditionIcdCodeChapterDto | null {
    return {
      type: this.type,
      chapters: this.chapters,
    };
  }

  toText(): string | null {
    return 'ICD-Kapitel';
  }

  toValue(): AysCodeGroup[] {
    return this.chapters;
  }
}

export class BdIcdChapterContentCondition extends BdContentCondition<AysCodeGroup> {
  constructor(includes: AysCodeGroup[], excludes: AysCodeGroup[]) {
    super(BD_ICD_CHAPTER_CONTENT_CONDITION_ID, includes, excludes);
  }
}

interface FilterConditionIcdCodeChapterDto {
  type: string;
  chapters: AysCodeGroup[];
}
